import { gsap } from 'gsap';
import SwiperImageCarousel from '../components/swiper/swiperCarousel';

class Home {
  constructor() {
    this.dom = {
      heroCaption: document.getElementById('hero').querySelector('.caption'),
      aboutImageCarousel: document.getElementById('about-image-carousel'),
      aboutNavigationCarousel: document.getElementById('about-navigation-carousel'),
      casesCarousel: document.getElementById('cases-carousel'),
    };

    this.components = {
      aboutImageCarousel: null,
      aboutNavigationCarousel: null,
      casesCarousel: null,
    };
  }

  mount() {
    this.animateHero().initAboutSwiper().initCasesCarousel();
  }

  animateHero() {
    gsap.from(this.dom.heroCaption, {
      x: -200,
      opacity: 0,
      duration: 0.5,
      delay: 0.5,
      ease: 'power1.out',
    });
    return this;
  }

  initAboutSwiper() {
    if (!this.dom.aboutImageCarousel) {
      return this;
    }

    this.initAboutNavigationCarousel();

    const aboutImageCarouselOptions = {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      thumbs: {
        swiper: this.components.aboutNavigationCarousel
          ? this.components.aboutNavigationCarousel.components.swiperInstance
          : null,
      },
    };
    this.components.aboutImageCarousel = new SwiperImageCarousel({ swiperEl: this.dom.aboutImageCarousel, options: aboutImageCarouselOptions }).mount();

    return this;
  }

  initAboutNavigationCarousel() {
    if (!this.dom.aboutNavigationCarousel) {
      return this;
    }

    const aboutNavigationCarouselOptions = {
      slidesPerView: 4,
      spaceBetween: 0,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
    };
    this.components.aboutNavigationCarousel = new SwiperImageCarousel({ swiperEl: this.dom.aboutNavigationCarousel, options: aboutNavigationCarouselOptions }).mount();

    return this;
  }

  initCasesCarousel() {
    if (!this.dom.casesCarousel) {
      return this;
    }

    const casesCarouselOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 3,
        },
        1240: {
          slidesPerView: 4,
        },
      },
    };
    this.components.casesCarousel = new SwiperImageCarousel({ swiperEl: this.dom.casesCarousel, options: casesCarouselOptions }).mount();

    return this;
  }
}

if (document.getElementById('page-home')) {
  new Home().mount();
}
